import React, { useCallback, useEffect, useState } from 'react';

import { useAppDispatch } from 'hooks/useAppDispatch';
import { getAssignmentTerminationAttachmentFileAll } from 'redux/reducers/assignmentSlice';
import {
  AssignmentTerminationModel,
  ResourceDownloadResponse,
} from 'api/backofficeApiClient';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';
import TerminationAssignmentForm from './TerminationAssignmentForm';

type Props = {
  onClose: () => void;
  assignmentId: string;
  onSuccess?: () => Promise<void>;
  assignmentTerminationDetails?: AssignmentTerminationModel;
  isPendingAssignment?: boolean;
  mode?: TerminationModeEnum;
  title?: string;
};

export enum TerminationModeEnum {
  View = 1,
}

export default function TerminateAssignmentModal(props: Props) {
  const { assignmentId } = props;
  const [assignmentTerminationFiles, setAssignmentTerminationFiles] =
    useState<ResourceDownloadResponse[]>();
  const [isTerminationFilesLoaded, setIsTerminationFilesLoaded] =
    useState(false);
  const isAdminRole = useAppSelector(isAdminSelector);
  const dispatch = useAppDispatch();

  const loadAssignmentTerminationFiles = useCallback(async () => {
    if (!assignmentId) return;

    const result = await dispatch(
      getAssignmentTerminationAttachmentFileAll({
        assignmentId: assignmentId,
        isAdmin: isAdminRole,
      }),
    );

    if (getAssignmentTerminationAttachmentFileAll.fulfilled.match(result)) {
      setAssignmentTerminationFiles(result.payload);
    } else {
      setAssignmentTerminationFiles([]);
    }
    setIsTerminationFilesLoaded(true);
  }, [dispatch, assignmentId, isAdminRole]);

  useEffect(() => {
    loadAssignmentTerminationFiles();
  }, [loadAssignmentTerminationFiles]);

  if (!isTerminationFilesLoaded) return null;

  return (
    <TerminationAssignmentForm
      {...props}
      assignmentTerminationFiles={assignmentTerminationFiles}
    />
  );
}
